/*global google*/

import Typography from '@material-ui/core/Typography';
import { RemoveShoppingCartSharp } from '@material-ui/icons';
import React, { Component } from "react";
import {
    withGoogleMap,
    withScriptjs,
    GoogleMap,
    DirectionsRenderer
} from "react-google-maps";


class Mapacards extends Component{

  constructor(props) {
    super(props);
     this.state = {
    directions:null,  directions2:null, itinerarioida: [], itinerariovolta:[],
    directionsdestino: null, directionssaida: null, geosaida:null, geovolta:null,
    distancia: null, tempo:null, tempototalvolta:null ,distancia2: null, listaparadasida: null, listaparadsavolta:null,
};
  }
    
 

  
    


 // React.useEffect(() => {

componentDidMount() {

 
  
  console.log('dentro do map destino', this.props.destino);
    //const destino;
    const directionsService = new google.maps.DirectionsService();
    const directionsServiceretorno = new google.maps.DirectionsService();
  
   var geodestino=""
   var geosaida=""
    var saida='';
    var dest='';
    var listapida= this.props.listaparadasida;
    var litsapvolta = this.props.listaparadasvolta;
    var listaida=[];
    var listavolta=[];
    var totalvolta='';
    
    //const destination1 = { lat: -29.7215493, lng:  -53.71837069999999 };
    
    //**********************************geo destino */
    
 
    
 //*************************gerar geocode paradas volta 
 
    

   

 //*************************gerar geocode saida  */
    
 

    const geramapa=()=>{

        if((listapida!=undefined)&&(listapida[0].lat!='')){

    
            for (let index = 0; index < listapida.length; index++) {
              
                 listaida.push({location: new google.maps.LatLng(listapida[index].lat,listapida[index].lng)})
                     
              
            }
            
         
        }
        
     // console.log("Geocode was not successful for the following reason: " , saida),
      //console.log("Geocode was not successful for the following reason: " ,dest),
      directionsService.route(
        //var des={lat:latitude, lng:longitude},
         {
            
              origin: this.props.saida,
              destination:  this.props.destino,
              travelMode: google.maps.TravelMode.DRIVING,
           waypoints: listaida,
                 /*[ {
                      location: new google.maps.LatLng(6.4698,  3.5852)
                  },
                  {
                      location: new google.maps.LatLng(6.6018,3.3515)
                  }
              ]*/
          },
          (result, status) => {
              if (status === google.maps.DirectionsStatus.OK) {
                  console.log('aqui ida',result.routes[0]);
                  console.log('aqui ida',result);

                  var total = 0;
                  var tempoida=0;
                  var myroute = result.routes[0];
                var leg = result.routes[0].legs;

                  console.log(`error fetching directions ` );
                  this.setState({
                    itinerarioida: leg
                    //console.log(`error fetching directions ` );
                });

                  for (var i = 0; i < myroute.legs.length; i++) {
                    total += myroute.legs[i].distance.value;
                    tempoida += myroute.legs[i].duration.value;
                  }
                  //total = total / 1000;
                  tempoida = tempoida/60
                  
                 
                this.setState({
                  tempo: tempoida.toFixed(0)
                  //console.log(`error fetching directions ` );
              });
                  //res=result;
                  var totalf = total + totalvolta;
                  totalf = totalf/1000
                  var t = totalf.toFixed(3);
                  //this.props.setakm(totalf);
                  this.setState({
                    distancia: totalf
                    //console.log(`error fetching directions ` );
                })
                  this.setState({
                      directions: result
                      //console.log(`error fetching directions ` );
                  });
                 
              } else {
                  console.error(`error fetching directions ${result}`);
              }
          }
      )
      
        }


  const geramaparetorno=()=>{

    if((litsapvolta!=undefined)&&(litsapvolta!=false)){
        for (let index = 0; index < listapida.length; index++) {
          listavolta.push({location: new google.maps.LatLng(litsapvolta[index])})
          
        }
      }
    // console.log("Geocode was not successful for the following reason: " , saida),
     //console.log("Geocode was not successful for the following reason: " ,dest),
     directionsServiceretorno.route(
       //var des={lat:latitude, lng:longitude},
       {
            
        origin:  this.props.destino,
        destination:  this.props.saida,
        travelMode: google.maps.TravelMode.DRIVING,
     waypoints: listavolta,
          
    },
    (results, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
            console.log('aqui volta',results.routes[0].legs[0].distance.value);
            console.log('aqui volta',results);
            var tempovolta=0;
                  var total = 0;
                  var myroute = results.routes[0];
                  var leg = results.routes[0].legs;

                  this.setState({
                    itinerariovolta: leg
                    //console.log(`error fetching directions ` );
                });

                  for (var i = 0; i < myroute.legs.length; i++) {
                    total += myroute.legs[i].distance.value;
                    tempovolta += myroute.legs[i].duration.value;
                  }
                  //total = total / 1000;
                  tempovolta = tempovolta
                  //alert(`error fetching directions `, tempovolta);
                  this.setState({
                    tempototalvolta: tempovolta
                    
                });
               // alert(tempovolta);
                //this.props.setatemporetorno(tempovolta);
           
            totalvolta=total;
           
           geramapa();

        } else {
            console.error(`error fetching directions ${results}`);
        }
    }
)
     
}

geramaparetorno();
    

   
   
 
    
    
      
    
    
//},[props])


    
}





render() {

    const GoogleMapExample = withGoogleMap(props => (
        <GoogleMap
            defaultCenter={{ lat: -29.7215493, lng:  -53.71837069999999 }}
            defaultZoom={1}
        >
          {console.log("putssss" , this.state.directions)}
            <DirectionsRenderer
                directions={this.state.directions}
            />
        </GoogleMap>

        
    )
    
    
    );

    console.log(this.state.itinerarioida);
    console.log('ppppppp');
  var logs =  this.state.itinerarioida.map(item=>(
      <Typography variant="body2" color="textSecondary" component="p">
     De: {item.start_address }
     <br></br>
     Para:{item.end_address}
     <br></br>
     Tempo previsto de deslocamento: {item.duration.text}
      
      
    </Typography>

   ));
   var logsvolta =  this.state.itinerariovolta.map(item=>(
    <Typography variant="body2" color="textSecondary" component="p">
   De: {item.start_address }
   <br></br>
   Para:{item.end_address}
   <br></br>
   Tempo previsto de deslocamento: {item.duration.text}
    
    
  </Typography>

 ))

   /* const GoogleMapExampleretorno = withGoogleMap(props => (
      <GoogleMap
          defaultCenter={{ lat: -29.7215493, lng:  -53.71837069999999 }}
          defaultZoom={1}
      >
        {console.log("putssss1111" , this.state.directions2)}
          <DirectionsRenderer
              directions={this.state.directions2}
          />
      </GoogleMap>
       )
    
    
       );*/

    

    return (
      
      
        <div>
          
         
          

             <Typography variant="body2" color="textSecondary" component="p">
              Itinerário Completo de ida: 
              
              {logs}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
            <br></br>
              <br></br>
              Itinerário Completo de retorno: 
              
              {logsvolta}
              <br></br>
            </Typography>

            
           
             <GoogleMapExample
            containerElement={<div style={{ height: `400px`, width: "500px" }} />}
            mapElement={<div style={{ height: `100%` }} />}
        />







        </div>
        


       );
    }
}

export default Mapacards;

/*


<Typography variant="body2" color="textSecondary" component="p">
               Local de Saida: {this.state.directionssaida}
               <br></br>
             </Typography>
            
             <Typography variant="body2" color="textSecondary" component="p">
               Local de Destino: {this.state.directionsdestino}
              
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
              
               Tempo previsto para chegada ao destino: {this.state.tempo} minutos.
               
             </Typography>
*/